import React from "react";
import
{
    Form,
    Button,
    Modal,
    FormGroup,
    Input,
    Label,
    ModalHeader,
    ModalBody
} from "reactstrap";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
const validator = require("../../../../utils/validator/validator");
const stringUtil = require("../../../../utils/string/stringUtil");
const translator = require("../../../../utils/translator/translator");

class OpenDiscount extends React.Component
{
    constructor(props)
    {
        super(props);
        const { code, type, amount } = this.props.values || {};
        this.state = {
            openDiscount: {
                code: code || '',
                type: type || 'percentage',
                amount: amount || ''
            },
            error: {
                fieldName: '',
                message: ''
            },
            showModal: true
        }
        this.updateOpenDiscount = this.updateOpenDiscount.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.hasErrors = this.hasErrors.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.inputFieldRef = React.createRef();
    }

    updateOpenDiscount(fieldName, fieldValue)
    {
        const openDiscount = { ...this.state.openDiscount };
        openDiscount[fieldName] = fieldValue;
        this.setState({ openDiscount });
    }

    handleModalOpen()
    {
        this.inputFieldRef.current.focus();
    }

    hasErrors()
    {
        const openDiscount = this.state.openDiscount;
        let error;

        if (stringUtil.isStringNullOrEmpty(openDiscount.code))
        {
            error = {
                fieldName: 'code',
                message: translator.getLabel("discount_code_cannot_be_empty")
            }
        }
        else if (!(validator.isNumeric(openDiscount.amount) && parseFloat(openDiscount.amount) > 0)) 
        {
            error = {
                fieldName: 'amount',
                message: translator.getLabel("discount_amount_should_be_a_number_greater_than_0")
            }
        }
        else if (openDiscount.type === "percentage" && parseFloat(openDiscount.amount) > 100)
        {
            error = {
                fieldName: 'amount',
                message: translator.getLabel("discount_amount__percentage_cannot_be_greater_than_100")
            }
        }
        else
        {
            error = {
                fieldName: '',
                message: ''
            }
        }

        return error;
    }

    handleCancel()
    {
        if (typeof this.props.onCancel === "function")
        {
            this.props.onCancel();
        }
    }

    handleSubmit(e)
    {
        e.preventDefault();
        const error = this.hasErrors();
        this.setState({ error });
        if (!error.fieldName)
        {
            if (typeof this.props.onSubmit === "function")
            {
                this.props.onSubmit(this.state.openDiscount);
            }
        }
    }

    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false} onOpened={this.handleModalOpen} size="lg">
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.handleCancel}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                            <Button className="btn-ok" type="submit" form="openDiscountForm">{translator.getLabel("done")}</Button>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel("open_discount")}</span>
                </ModalHeader>
                <ModalBody>
                    <Form id="openDiscountForm" onSubmit={this.handleSubmit} >
                        <div className="mb-3">
                            <InputTextComponent
                                autoComplete="off"
                                placeholder={translator.getLabel("open_discount_code")}
                                value={this.state.openDiscount.code}
                                onValueChange={(value) => { this.updateOpenDiscount('code', value) }}
                                inputTextType="text"
                                error={this.state.error.fieldName === "code" ? this.state.error.message : ''}
                                internalRef={this.inputFieldRef}
                            />
                        </div>
                        <FormGroup className="d-flex gap-3">
                            <div style={{ paddingLeft: '3px' }}>
                                <Input
                                    id="percentage"
                                    type="radio"
                                    name="type"
                                    value="percentage"
                                    onChange={(e) => { this.updateOpenDiscount('type', e.target.value) }}
                                    checked={this.state.openDiscount.type === "percentage"}
                                />
                                {' '}
                                <Label for="percentage">{translator.getLabel("percentage_discount")}</Label>
                            </div>
                            <div style={{ paddingLeft: '3px' }}>
                                <Input
                                    id="flat"
                                    type="radio"
                                    name="type"
                                    value="flat"
                                    onChange={(e) => { this.updateOpenDiscount('type', e.target.value) }}
                                    checked={this.state.openDiscount.type === "flat"}
                                />
                                {' '}
                                <Label for="flat">{translator.getLabel("flat_discount")}</Label>
                            </div>
                        </FormGroup>
                        <div>
                            <InputTextComponent
                                placeholder={translator.getLabel(this.state.openDiscount.type === "percentage" ? "open_discount_percentage" : "open_discount_flat")}
                                autoComplete="off"
                                value={this.state.openDiscount.amount}
                                onValueChange={(value) => { this.updateOpenDiscount('amount', value) }}
                                inputTextType="numeric"
                                error={this.state.error.fieldName === "amount" ? this.state.error.message : ''}
                            />
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        );
    }
}


export default OpenDiscount;